import { useState, useEffect } from "react";
import { Typography, Box, CardMedia } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import { toMoney } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import { UseOrders } from "./UseOrders";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { Circle } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
import deliveryExpress from "../../images/svg/Delivery_Motor_Express.svg";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";

export default function OrdersGrid(props) {
  const { getOrdersList } = UseOrders();
  const location = useLocation();
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("Id", "Desc");
  const [backID, setBackID] = useState("");
  const [searchColumn, setSearchColumn] = useState("");
  const [ordersRes, setOrdersRes] = useState();

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (props.searchColumn) {
      setSearchColumn(props.searchColumn);
    }
  }, [props.searchColumn]);

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setOrdersRes();
    setProgress(true);
    getOrdersList(
      myPc,
      searchColumn,
      searchParams ? searchParams.get("state") : 1,
      props.orderFilter,
      props.search ? props.search : "",
      (Orders) => {
        props.setStateCounts(Orders.statics);
        setOrdersRes(Orders);
      },
      true
    );
  }, [myPc, props.search, searchColumn, searchParams, props.orderFilter]);

  useEffect(() => {
    if (props.refresh) {
      setScrollTo({ top: 0, left: 0 });
      updatePage(1);
      setProgress(true);
      getOrdersList(
        myPc,
        searchColumn,
        searchParams ? searchParams.get("state") : 1,
        props.orderFilter,
        props.search ? props.search : "",
        (Orders) => {
          props.setRefresh(false);
          props.setStateCounts(Orders.statics);
          setOrdersRes(Orders);
        },
        true
      );
    }
  }, [props.refresh]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
      setBackID(location.state.id);
    }
    if (props.search && props.search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [props.search]);

  const columns = [
    {
      field: "waiting",
      width: 50,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderHeader: (cellValues) => {
        return "";
        // <HourglassBottomIcon fontSize="small" sx={{ fill: "#626262" }} />
      },
      renderCell: (cellValues) => {
        return props.orderFilter == 6 ? (
          <>
            <HourglassEmptyOutlinedIcon
              onClick={() => {
                setScrollTo(cellValues.api.getScrollPosition());
              }}
              fontSize="small"
              sx={{
                fill: "#626262",
                // width: "40px",
                m: 0,
              }}
            />
            {cellValues.row.isExpress && (
              <CardMedia
                sx={{ width: "30px", m: 0 }}
                component="img"
                image={deliveryExpress}
              />
            )}
          </>
        ) : cellValues.row.isExpress ? (
          <CardMedia
            sx={{ width: "30px", m: 0 }}
            component="img"
            image={deliveryExpress}
          />
        ) : (
          ""
        );
      },
    },
    {
      field: "id",
      width: 100,
      align: "center",
      headerName: "سفارش",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return backID ? (
          <Box
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            sx={{
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.id == backID && (
              <Circle fontSize="small" color="secondary" sx={{ mr: 0.5 }} />
            )}

            <Typography
              variant="span"
              sx={{
                direction: "ltr",
              }}
            >
              {cellValues.row.id}
            </Typography>
          </Box>
        ) : (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              direction: "ltr",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.id}
          </Typography>
        );
      },
    },
    {
      field: "ShamsiLogDate",
      headerName: "تاریخ",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              direction: "rtl",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.shamsiLogDate}
          </Typography>
        );
      },
    },
    {
      field: "fullName",
      headerName: "نام و نام خانوادگی",
      width: 170,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "start",
              display: "flex",
              alignItems: "center",
            }}
          >
            {cellValues.row.fullName}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "موبایل",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {cellValues.row.mobile}
          </Typography>
        );
      },
    },
    {
      field: "city",
      headerName: "شهر",
      width: 120,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "start",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            {cellValues.row.city}
          </Typography>
        );
      },
    },
    {
      field: "payment",
      headerName: "نوع خرید",
      width: 120,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            {cellValues.row.payment}
          </Typography>
        );
      },
    },
    {
      field: "totalPayment",
      headerName: "قیمت",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {cellValues.row.totalPayment
              ? toMoney(cellValues.row.totalPayment)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "state",
      headerName: "وضعیت",
      width: 140,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            onClick={() => {
              setScrollTo(cellValues.api.getScrollPosition());
            }}
            variant="span"
            sx={{
              whiteSpace: "normal",
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            {cellValues.row.state}
          </Typography>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "100%" }}>
      {ordersRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={ordersRes.pageCondition.pageCount}
          rows={ordersRes.orders}
          paginationMode="server"
          page={ordersRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          disableVirtualization
          rowCount={ordersRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
              {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
            "& .MuiDataGrid-cell:hover": {
              opacity: "80%",
              cursor: "pointer",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .white": {
              backgroundColor: "#ffffff !important",
            },
            "& .orange": {
              backgroundColor: "#FFC36E !important",
            },
            "& .beige": {
              backgroundColor: "#FFE7B4 !important",
            },
            "& .yasi": {
              backgroundColor: "#eacdff !important",
            },
            "& .Green": {
              backgroundColor: "#56ff004f !important",
            },
            "& .red": {
              backgroundColor: "#ff9c9c !important",
            },
            "& .pink": {
              backgroundColor: "#ffdbdb !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.state && params.row.state == "نامشخص") {
              return "white";
            }
            if (params.row.state && params.row.state == "در حال حسابرسی") {
              return "orange";
            }
            if (params.row.state && params.row.state == "بررسی شده") {
              return "beige";
            }
            if (params.row.state && params.row.state == "در حال ارسال") {
              return "yasi";
            }
            if (params.row.state && params.row.state == "تایید شده") {
              return "Green";
            }
            if (
              (params.row.state && params.row.state == "تایید نشده") ||
              (params.row.state && params.row.state == "عدم تایید حسابرسی")
            ) {
              return "red";
            }
            if (params.row.state && params.row.state == "آنلاین نا موفق") {
              return "pink";
            }
          }}
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              nofab: true,
              rowCount:
                ordersRes && ordersRes.pageCondition.totalItemCount
                  ? ordersRes.pageCondition.totalItemCount
                  : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
          onRowClick={(row, cellValues) => {
            // setScrollTo({ top: evt.pageY, left: 0 });
            return navigate(`/orders/orderDetail?oid=${row.row.id}`, {
              state: {
                model: row.row,
                myPc: myPc,
                search: props.search,
                id: row.row.id,
                searchColumn: props.searchColumn,
                searchName: props.searchName,
                orderState: props.orderState,
                orderFilter: props.orderFilter,
              },
            });
          }}
        />
      ) : (
        <ProgressCom />
      )}
    </Box>
  );
}
